import React, { useState } from "react";
import { useNavigate, Link, Navigate } from "react-router-dom";
import { useCustomerAuth } from "@/context/CustomerAuthContext";
import PublicLayout from "@/components/public/PublicLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function CustomerRegister() {
  const { register, customer } = useCustomerAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [busy, setBusy] = useState(false);
  if (customer) return <Navigate to="/account" replace />;
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    setBusy(true);
    try { await register({ ...form, email: form.email.trim().toLowerCase() }); toast.success("Account created"); navigate("/account"); }
    catch (err) { toast.error(err.response?.data?.detail || "Registration failed"); }
    finally { setBusy(false); }
  };

  return (
    <PublicLayout>
      <section className="max-w-md mx-auto px-5 py-20">
        <div className="text-center mb-8">
          <div className="text-[#c9a86a] tracking-[0.3em] text-xs mb-2">CLIENT ACCOUNT</div>
          <h1 className="text-2xl font-semibold text-[var(--text)]">Create your account</h1>
          <p className="text-sm text-[var(--muted)] mt-2">If you've joined the VIP list with this email, your tier carries over.</p>
        </div>
        <form onSubmit={submit} className="bg-[var(--panel-2)] border border-[var(--border-2)] rounded-xl p-8 space-y-5" data-testid="customer-register-form">
          <div className="space-y-2"><Label className="text-[var(--text-2)]">Full Name</Label><Input value={form.name} onChange={(e) => set("name", e.target.value)} required className="bg-[var(--bg)] border-[var(--border-2)] text-[var(--text)]" data-testid="reg-name" /></div>
          <div className="space-y-2"><Label className="text-[var(--text-2)]">Email</Label><Input type="email" value={form.email} onChange={(e) => set("email", e.target.value)} required className="bg-[var(--bg)] border-[var(--border-2)] text-[var(--text)]" data-testid="reg-email" /></div>
          <div className="space-y-2"><Label className="text-[var(--text-2)]">Phone (optional)</Label><Input value={form.phone} onChange={(e) => set("phone", e.target.value)} className="bg-[var(--bg)] border-[var(--border-2)] text-[var(--text)]" /></div>
          <div className="space-y-2"><Label className="text-[var(--text-2)]">Password</Label><Input type="password" value={form.password} onChange={(e) => set("password", e.target.value)} required className="bg-[var(--bg)] border-[var(--border-2)] text-[var(--text)]" data-testid="reg-password" /></div>
          <Button type="submit" disabled={busy} data-testid="reg-submit" className="w-full bg-[#c9a86a] hover:bg-[#b89455] text-[var(--on-gold)] font-semibold rounded-none">{busy ? "Creating…" : "Create Account"}</Button>
        </form>
        <p className="text-center text-sm text-[var(--muted)] mt-6">Already have an account? <Link to="/account/login" className="text-[#c9a86a] hover:text-[#b89455] transition-colors">Sign in</Link></p>
      </section>
    </PublicLayout>
  );
}
